export class AppUtils {
    static checkWXJSApi(callback) {
        if (typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge.invoke === 'function') {
            callback();
        }
        else {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', callback, false);
            }
            else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', callback);
                document.attachEvent('onWeixinJSBridgeReady', callback);
            }
        }
    }
    ;
    static getFirstTiming() {
        const t = performance.timing;
        return {
            dnsLookup: t.domainLookupEnd - t.domainLookupStart,
            tcp: t.connectEnd - t.connectStart,
            ssl: t.secureConnectionStart === 0 ? 0 : t.requestStart - t.secureConnectionStart,
            ttfb: t.responseStart - t.requestStart,
            contentDownload: t.responseEnd - t.responseStart,
            domParse: t.domInteractive - t.domLoading,
            resourceDownload: t.loadEventStart - t.domInteractive
        };
    }
    static buildParam(obj) {
        const str = [];
        for (const k in obj) {
            if (obj.hasOwnProperty(k)) {
                const v = obj[k];
                if (Array.isArray(v)) {
                    v.forEach((value, index) => {
                        str.push(`${this.onceEncodeURIComponent(k)}[${index}]=${this.onceEncodeURIComponent(value)}`);
                    });
                }
                else {
                    str.push(`${this.onceEncodeURIComponent(k)}=${this.onceEncodeURIComponent(v)}`);
                }
            }
        }
        return str.join('&');
    }
    static onceEncodeURIComponent(str) {
        try {
            return encodeURIComponent(decodeURIComponent(str));
        }
        catch (e) { }
    }
}
//# sourceMappingURL=appUtils.js.map